module.exports = "/_next/static/files/4c8424b7f55546bc3c1a3109fca2140e.svg";